import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Classes from "./ViewSubscriptionPage.module.css";
import MoreDropDown from "./MoreDropDown";
import Logo from "../../../../LocalComp/Logo/Logo";
import DropDown from "../StatusDropDown/DropDown";

const LeftArrow = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 448 512">
        <path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" />
    </svg>
);

export default function ViewSubscriptionPage() {
    const navigateTo = useNavigate();

    return (
        <div className={Classes.container}>
            <div className={Classes.header}>
                <button onClick={() => navigateTo("/subscriptions")} className={Classes.backButton}>
                    <LeftArrow height='12px' fill='#969696' />
                    <h5>Subscriptions</h5>
                </button>
                <div className="flexAlign10" >
                    <MoreDropDown />
                </div>
            </div>

            <div className={Classes.hero} >
                <div className="flexAlign10" >
                    <h3> John Smith </h3>
                    <DropDown selectedValue="Active" isDropDown={false} />
                </div>
                <div className={Classes.grid} >
                    <div className={Classes.heroLeft}>
                        <h5 className={Classes.miniTitle} >Payments</h5>
                        <table className={Classes.table}>
                            <thead>
                                <tr>
                                    <th> <h5 className={Classes.lightDarkText} > Invoice </h5> </th>
                                    <th> <h5 className={Classes.lightDarkText} > Date </h5> </th>
                                    <th> <h5 className={Classes.lightDarkText} > Total </h5> </th>
                                    <th> <h5 className={Classes.lightDarkText} > Status </h5> </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <h5 className={Classes.itemLink} >
                                            587FHA9
                                        </h5>
                                    </td>
                                    <td> <h5> SEO </h5> </td>
                                    <td> <h5> March 1, 2025 </h5> </td>
                                    <td>
                                        <DropDown selectedValue="Success" isDropDown={false} />
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <h5 className={Classes.miniTitle} >Orders</h5>
                        <table className={Classes.table}>
                            <thead>
                                <tr>
                                    <th> <h5 className={Classes.lightDarkText} > ID </h5> </th>
                                    <th> <h5 className={Classes.lightDarkText} > Title </h5> </th>
                                    <th> <h5 className={Classes.lightDarkText} > Created </h5> </th>
                                    <th> <h5 className={Classes.lightDarkText} > Status </h5> </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <h5 className={Classes.itemLink} >
                                            587FHA9
                                        </h5>
                                    </td>
                                    <td> <h5> SEO </h5> </td>
                                    <td> <h5> March 1, 2025 </h5> </td>
                                    <td>
                                        <DropDown selectedValue="Working" isDropDown={false} />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className={Classes.heroRight} >
                        <div className={Classes.invoice} >
                            <div className={Classes.invoiceListCon} >
                                <h5 className={Classes.miniTitle} style={{ marginBottom: '10px' }} >Details</h5>
                                <div>
                                    <h5 className={Classes.lightText} >Number</h5>
                                    <h5 className={Classes.lightText} style={{ color: 'black' }} >58YFJ</h5>
                                </div>
                                <div>
                                    <h5 className={Classes.lightText} >Created</h5>
                                    <h5 className={Classes.lightText} style={{ color: 'black' }} >Mar 1, 2025</h5>
                                </div>
                                <div>
                                    <h5 className={Classes.lightText} >Next payment</h5>
                                    <h5 className={Classes.lightText} style={{ color: 'black' }} >Mar 1, 2025</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
}